<template v-if="items">
  <div :class="muiMenuClassNames" ref="menu" @keydown.esc="close">
    <span class="mui_menu__button" v-on:click="handleToggle">
      <slot name="button"></slot>
      <i class="material-icons" v-if="showCaret">{{caret}}</i>
    </span>
    <div class="mui-menu__container" v-show="open">
      <div class="mui-menu__items mui-list" role="menu" aria-hidden="true">
        <MUIListItem
          v-for="(item, index) in items"
          :key="index"
          role="menuitem"
          :text="item.name"
          @click.native="onClick(index, $event)" />
      </div>
    </div>
  </div>
</template>

<script>
import MUIListItem from './MUIListItem'
export default {
  props: {
    anchor: {
      type: String,
      default: 'left'
    },
    items: Array,
    showCaret: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MUIListItem
  },
  computed: {
    caret () {
      return this.open ? 'arrow_drop_up' : 'arrow_drop_down'
    },
    muiMenuClassNames () {
      return {
        'mui-menu': true,
        [`mui-menu--anchor-${this.anchor}`]: true
      }
    }
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    onClick (index, ev) {
      this.items[index].fn(index, ev)
      this.handleClose()
    },
    onKeyDownEscape (ev) {
      var keycode = ((typeof ev.keyCode !== 'undefined' && ev.keyCode) ? ev.keyCode : ev.which)
      if (keycode === 27) this.handleClose()
    },
    onDocumentClick (ev) {
      let el = this.$refs.menu
      let target = ev.target
      if (el && el !== target && !el.contains(target)) {
        ev.stopPropagation()
        this.handleClose()
      }
    },
    handleClose () {
      this.open = false
    },
    handleToggle () {
      this.open = !this.open
    }
  },
  watch: {
    open () {
      if (this.open) {
        window.addEventListener('keydown', this.onKeyDownEscape)
        document.addEventListener('click', this.onDocumentClick)
        document.body.style.pointerEvents = 'none'
      } else {
        window.removeEventListener('keydown', this.onKeyDownEscape)
        document.removeEventListener('click', this.onDocumentClick)
        document.body.style.pointerEvents = 'all'
      }
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-menu
  cursor: pointer
  position: relative
  display: inline-block
.mui_menu__button, .mui_menu__button .cm-button
  cursor: pointer
.mui-menu__container
  font: $textFont
  letter-spacing: $uiFontLetterSpacing
  min-width: 170px
  max-width: calc(100vw - 32px)
  max-height: calc(100vh - 32px)
  margin: 8px 0 0
  padding: 0
  background-color: #ffffff
  white-space: nowrap
  overflow-x: hidden
  overflow-y: auto
  outline: none
  box-sizing: border-box
  .mui-menu--anchor-left &, .mui-menu--anchor-right &
    box-shadow: 0 0 0 1px rgba(99, 114, 130, 0.16), 0 4px 8px rgba(27, 39, 51, 0.08)
    border-radius: 2.4px
    position: absolute
    z-index: 4
  .mui-menu--anchor-left &
    left: 0
  .mui-menu--anchor-right &
    right: 0
  .mui-list
    margin: 0
    padding: 0
    pointer-events: auto
    outline: none
    list-style-type: none
  .mui-list-item
    color: $toolbarColor
    padding: 0 48px 0 24px
    align-items: center
    height: 60px
    &:hover
      background-color: #f7f9fa
  .mui-list-item__text
    font: $uiFont
</style>



// WEBPACK FOOTER //
// src/components/MUIMenu.vue